import React from 'react';
import { Truck } from 'lucide-react';
export function ShippingPolicyPage() {
  return <div className="bg-white min-h-screen pb-20" data-id="element-655">
      {/* Page Header */}
      <div className="bg-gray-50 border-b border-gray-200 py-16 px-4 sm:px-6 lg:px-8" data-id="element-656">
        <div className="max-w-4xl mx-auto text-center" data-id="element-657">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-658">
            <Truck className="w-8 h-8 text-[#0e7be1]" data-id="element-659" />
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900" data-id="element-660">
              Shipping Policy
            </h1>
          </div>
          <div className="w-24 h-1 bg-[#0e7be1] mx-auto rounded-full" data-id="element-661"></div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-662">
        <div className="prose prose-lg max-w-none" data-id="element-663">
          <section className="mb-8" data-id="element-664">
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-665">
              Shipping Information
            </h2>
            <p className="text-gray-600 leading-relaxed" data-id="element-666">
              Shipping rates vary based on product type and destination.
            </p>
          </section>

          <section className="bg-green-50 border-l-4 border-green-500 p-6 rounded-r-lg mb-8" data-id="element-667">
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-668">
              Shipping Deadline
            </h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-669">
              Orders placed before <strong data-id="element-670">3:00 PM EST</strong> on business days
              will be processed and shipped the same day.
            </p>
          </section>

          <section className="bg-gray-50 border-l-4 border-gray-400 p-6 rounded-r-lg mb-8" data-id="element-671">
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-672">
              Shipping Department Schedule
            </h3>
            <p className="text-gray-700 leading-relaxed mb-2" data-id="element-673">
              The shipping department is closed on{' '}
              <strong data-id="element-674">Saturdays, Sundays, and major holidays</strong>. Orders
              placed during these times will be processed on the next business
              day.
            </p>
          </section>

          <section className="bg-blue-50 border-l-4 border-[#0e7be1] p-6 rounded-r-lg mb-8" data-id="element-675">
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-676">
              Important Information for Hawaii Orders:
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4" data-id="element-677">
              Shipping costs for Hawaii may vary depending on the products
              ordered. Customers will be contacted with the applicable shipping
              price prior to order fulfillment.
            </p>
            <p className="text-gray-700 leading-relaxed" data-id="element-678">
              If you have questions about shipping, please contact us before
              placing your order.
            </p>
          </section>
        </div>
      </div>
    </div>;
}